// extracted by mini-css-extract-plugin
module.exports = {"container":"_f5975fb","main":"_6800158","delimeter":"_72377dc","record":"_3cbf2bd","exchangeRate":"_440811e","avatar":"_080c509","sign":"_a83f884"};